import { apiClient } from './api/client';

export type HomeBoxType = 'collection' | 'coming_soon';

export interface HomeBox {
  id: number;
  title: string;
  description: string | null;
  badge: string | null;
  background_image_url: string | null;
  slug: string;
  box_type?: HomeBoxType;
  status: 'draft' | 'published';
  display_order: number;
  product_ids: number[];
}

export interface HomeBoxPayload {
  title: string;
  description?: string;
  badge?: string;
  background_image_url?: string;
  slug?: string;
  status?: 'draft' | 'published';
  display_order?: number;
  product_ids: number[];
}

const createHomeBoxesService = (basePath: string) => ({
  async getPublic(): Promise<HomeBox[]> {
    return apiClient.get<HomeBox[]>(`${basePath}/public`);
  },
  async getPublicBySlug(slug: string): Promise<HomeBox> {
    return apiClient.get<HomeBox>(`${basePath}/public/${encodeURIComponent(slug)}`);
  },
  async getAllAdmin(): Promise<HomeBox[]> {
    return apiClient.get<HomeBox[]>(basePath);
  },
  async create(payload: HomeBoxPayload): Promise<HomeBox> {
    return apiClient.post<HomeBox>(basePath, payload);
  },
  async update(id: number, payload: HomeBoxPayload): Promise<HomeBox> {
    return apiClient.put<HomeBox>(`${basePath}/${id}`, payload);
  },
  async delete(id: number): Promise<void> {
    return apiClient.delete(`${basePath}/${id}`);
  },
});

export const homeBoxesService = createHomeBoxesService('/home-boxes');
export const homeComingBoxesService = createHomeBoxesService('/home-coming-boxes');
